import React, { useEffect, useState } from 'react'
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import { useSelector } from "react-redux";

const getErrorDetail = (error, file) => {
  const parts = [];
  if (file) {
    const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
    parts.push(`Skedari: ${file.name} (${sizeMB} MB, ${file.type || "i panjohur"})`);
  }
  if (error?.response) {
    parts.push(`HTTP ${error.response.status}`);
    parts.push(JSON.stringify(error.response.data, null, 2));
  } else {
    parts.push(error?.message || "Network Error");
    if (file?.size > 1024 * 1024) {
      parts.push("Shënim: foto e madhe mund të jetë bllokuar nga serveri (nginx limit).");
    }
  }
  return parts.join("\n\n");
};

export default function Collaborators() {
  const auth = useSelector(state => state.auth);

  const [collaborators, setCollaborators] = useState([]);
  const [loading, setLoading] = useState(false);

  // Forma e shtimit
  const [newFile, setNewFile] = useState(null);
  const [newPreview, setNewPreview] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [newLink, setNewLink] = useState("");
  const [newSort, setNewSort] = useState("");

  // Editimi inline (vlerat per rresht)
  const [editValues, setEditValues] = useState({});

  const apiData = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/getcollaborators");
      if (res.status === 200 && Array.isArray(res.data)) {
        setCollaborators(res.data);

        const values = {};
        res.data.forEach(c => {
          values[c._id] = {
            description: c.description || "",
            link: c.link || "",
            sort: c.sort != null ? c.sort : "",
            file: null
          };
        });
        setEditValues(values);
      } else {
        setCollaborators([]);
      }
    } catch (error) {
      console.error("Error loading collaborators:", error);
      setCollaborators([]);
    }
    setLoading(false);
  }

  useEffect(() => {
    apiData();
  }, [])

  const onSelectNewFile = (e) => {
    const file = e.target.files && e.target.files[0];
    setNewFile(file || null);
    setNewPreview(file ? URL.createObjectURL(file) : "");
  }

  const addCollaborator = async () => {
    if (!newFile) {
      alert("Ju lutem zgjidhni një foto!");
      return;
    }

    const formData = new FormData();
    formData.append("collaboratorImage", newFile);
    formData.append("description", newDescription || "");
    formData.append("link", newLink || "");
    formData.append("sort", newSort);

    try {
      const res = await axios.post("/addcollaborator", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.status === 200) {
        alert("Collaborator u shtua me sukses!");
        setNewFile(null);
        setNewPreview("");
        setNewDescription("");
        setNewLink("");
        setNewSort("");
        document.getElementById("newCollaboratorFile").value = "";
        apiData();
      }
    } catch (error) {
      console.error("Error adding collaborator:", error);
      alert(getErrorDetail(error, newFile));
    }
  }

  const setRowValue = (id, field, value) => {
    setEditValues(prev => ({
      ...prev,
      [id]: { ...prev[id], [field]: value }
    }));
  }

  const updateCollaborator = async (id) => {
    const values = editValues[id];
    if (!values) return;

    const formData = new FormData();
    formData.append("collaboratorId", id);
    formData.append("description", values.description || "");
    formData.append("link", values.link || "");
    formData.append("sort", values.sort);
    if (values.file) {
      formData.append("collaboratorImage", values.file);
    }

    try {
      const res = await axios.post("/updatecollaborator", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.status === 200) {
        alert("Collaborator u përditësua me sukses!");
        apiData();
      }
    } catch (error) {
      console.error("Error updating collaborator:", error);
      alert(getErrorDetail(error, values.file));
    }
  }

  const deleteCollaborator = async (id) => {
    if (!id) return;
    if (window.confirm("A jeni të sigurt që dëshironi të fshini këtë collaborator? Foto do të fshihet gjithashtu.")) {
      try {
        const res = await axios.post("/deletecollaborator", { collaboratorId: id });
        if (res.status === 200) {
          alert("Collaborator u fshi me sukses!");
          apiData();
        }
      } catch (error) {
        console.error("Error deleting collaborator:", error);
        alert(getErrorDetail(error, null));
      }
    }
  }

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}

        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Collaborators / Influencers
              <small>menaxho fotot dhe linket</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <a href="#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li className="active">Collaborators</li>
            </ol>
          </section>

          <section className="content">
            {/* SHTO COLLABORATOR */}
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Shto Collaborator të ri</h3>
              </div>
              <div className="box-body">
                <div className="row">
                  <div className="col-xs-3">
                    <label>Foto:</label>
                    <input
                      id="newCollaboratorFile"
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={onSelectNewFile}
                    />
                    {newPreview && (
                      <img
                        src={newPreview}
                        alt="preview"
                        style={{ marginTop: '8px', height: '80px', objectFit: 'cover' }}
                      />
                    )}
                  </div>
                  <div className="col-xs-3">
                    <label>Description:</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="p.sh. influencer 1"
                      value={newDescription}
                      onChange={(e) => setNewDescription(e.target.value)}
                    />
                  </div>
                  <div className="col-xs-4">
                    <label>Link (Instagram):</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="https://www.instagram.com/p/..."
                      value={newLink}
                      onChange={(e) => setNewLink(e.target.value)}
                    />
                  </div>
                  <div className="col-xs-2">
                    <label>Sort (1, 2, 3...):</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="auto"
                      value={newSort}
                      onChange={(e) => setNewSort(e.target.value)}
                    />
                  </div>
                </div>
                <br />
                <button className="btn btn-primary" onClick={addCollaborator}>
                  <i className="fa fa-plus" /> Shto Collaborator
                </button>
              </div>
            </div>

            {/* LISTA */}
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Lista e Collaborators ({collaborators.length})</h3>
              </div>
              <div className="box-body">
                {loading && <p>Duke ngarkuar...</p>}
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>#</th>
                      <th style={{ width: '110px' }}>Foto</th>
                      <th>Description</th>
                      <th>Link</th>
                      <th style={{ width: '90px' }}>Sort</th>
                      <th style={{ width: '200px' }}>Ndrysho Foton</th>
                      <th style={{ width: '130px' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {collaborators.map((c, idx) => (
                      <tr key={c._id}>
                        <td>{idx + 1}</td>
                        <td>
                          <a href={c.image} target="_blank" rel="noopener noreferrer">
                            <img
                              src={c.image}
                              alt={c.description}
                              height="60"
                              width="60"
                              style={{ objectFit: 'cover', borderRadius: '4px' }}
                            />
                          </a>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={editValues[c._id]?.description ?? ""}
                            onChange={(e) => setRowValue(c._id, "description", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={editValues[c._id]?.link ?? ""}
                            onChange={(e) => setRowValue(c._id, "link", e.target.value)}
                          />
                          {editValues[c._id]?.link && (
                            <a href={editValues[c._id].link} target="_blank" rel="noopener noreferrer">
                              <small>Hap linkun</small>
                            </a>
                          )}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={editValues[c._id]?.sort ?? ""}
                            onChange={(e) => setRowValue(c._id, "sort", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => setRowValue(c._id, "file", e.target.files?.[0] || null)}
                          />
                          {editValues[c._id]?.file && (
                            <small className="text-green">Foto e re e zgjedhur</small>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-info"
                            style={{ marginRight: '5px' }}
                            onClick={() => updateCollaborator(c._id)}
                            title="Ruaj ndryshimet"
                          >
                            <i className="fa fa-refresh" />
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => deleteCollaborator(c._id)}
                            title="Fshi këtë collaborator"
                          >
                            <i className="fa fa-trash" />
                          </button>
                        </td>
                      </tr>
                    ))}
                    {!loading && collaborators.length === 0 && (
                      <tr>
                        <td colSpan="7" className="text-center">
                          Nuk ka collaborators. Shtoni të parin më lart.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>

        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  )
}
